import React, { Component } from 'react';
import styled, { injectGlobal } from 'styled-components';
import { Element } from 'react-scroll'

import Home from './compontents/home';
import Streamers from './compontents/streamers';
import Discord from './compontents/discord';
import About from './compontents/about';
import Footer from './compontents/footer';
import data from './data';

const API = "/tsr.json"
const TWITCH_BASE_URL     = "https://api.twitch.tv/kraken/";
const CLIENT_ID           = "2yxakhma6fwzps1arne7oedrt0xod6";

injectGlobal`
  @font-face {font-family: 'BebasNeue';src: url('webfonts/35C76C_0_0.eot');src: url('webfonts/35C76C_0_0.eot?#iefix') format('embedded-opentype'),url('webfonts/35C76C_0_0.woff2') format('woff2'),url('webfonts/35C76C_0_0.woff') format('woff'),url('webfonts/35C76C_0_0.ttf') format('truetype');}

  *, *:after, *:before {
    margin: 0;
    padding;
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
  
  @keyframes bgZoom {
    0% {
      background-size: 180rem auto;
    }
    100% {
      background-size: 220rem auto; 
    }
  }

  body {
    font-family: 'BebasNeue';
    background: #2C2E32;
    color: #FFCA77;
    font-size: 2.4rem;
    letter-spacing: 0.05em;
    background-image: url("tsrbg.svg");
    background-position: 50% 70%;
    background-attachment: fixed;
    background-size: 220rem auto;
    // background-size: 180rem auto;


    // animation-name: bgZoom;
    // animation-duration: 2s; 
    // animation-iteration-count: 1;
    // animation-fill-mode: forwards;
    // animation-timing-function: cubic-bezier(.2,.3,0,1);   
    // animation-delay: 0.4s;


  }

  a {
    color: #FFCA77;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    
  }

  a:after {
    content: '';
    position: absolute;
    width: 0%;
    right: -10%;
    top: 50%;
    height: 2px;
    background: #FFCA77;
    transition: width 0.3s cubic-bezier(.78,.01,.13,1);
    backface-visibility: hidden;
    perspective: 100px;
  }

  a:hover:after,
  a.active:after {
    width: 120%;
    left: -10%; 
  }

  @keyframes fadeInUp {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes fadeInLeft {
    0% {
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  ::selection {
    background: #1a1c1e;
    color: #FFCA77;
  }
`

const Loading = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
`



class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isError: false,
      errorMsg: null,
      data: data,
      twitchDataIsLoading: true,
      twitchData: null,
    }
  }

  // componentDidMount() {
    // this.getData();
  // }

  getData() {
    fetch(API)
      .then(data => data.json())
      .then(data => {
        this.setState({ data, isLoading: false, isError: false });
        this.fetchStreamerStatus(data.streamers)
      })
  }

  fetchStreamerStatus(streamers) {
    const urlBase = TWITCH_BASE_URL + 'streams/'
    const urls = streamers.map(streamer => urlBase + streamer.twitch_id)
    Promise.all(urls.map(url => fetch(url, {
      headers: {
        'Accept': 'application/vnd.twitchtv.v5+json',
        'Client-ID': CLIENT_ID
      }
    })))
      .then(data => Promise.all(data.map(data => data.json())))
      .then(data => data.map(stream => {
        if(stream.stream !== null) {
          const channel = stream.channel.id;
          
        }
      }))
  }

  render() {
    const { data, isLoading } = this.state;

    if(isLoading) {
      return (<Loading>loading...</Loading>)
    }

    return (
      <div>
        <Element name="home">
          <Home/>
        </Element>
        <Element name="streamers">
          <Streamers data={data}/>
        </Element>
        <Element name="discord">
          <Discord data={data.discord}/>
        </Element>
        <Element name="about">
          <About data={data.about}/>
        </Element>
        <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js